/**
 * CSS class names applied imperatively to building / tier outline paths.
 *
 * Used by:
 * - `useSvgBuildingInteraction`
 * - `useSvgTierInteraction`
 * - Hero outline SCSS (`SvgOutlineLayer.module.scss`, `VisualizationView.module.scss`)
 *
 * Keep in sync with the outline path rules in those SCSS files.
 */
export const SVG_OUTLINE_CLASS = {
  HOVERED: 'outline-hovered',
  ACTIVE:  'outline-active',
  PREVIEW: 'outline-preview',
}
